import styled, { css } from 'styled-components'
import ExternalLink from '../../common/external-link'
import ChevronDownIcon from '../../../assets/icons/chevron-down.svg'
import { desktopBreakpoint, wideScreenBreakpoint } from 'react-components'

export const MegarbarWrapper = styled.div`
    background-color: #f5f5f5;
`

export const MegaBarContainer = styled.nav`
    display: none;
    width: 100%;
    height: 2.625rem;
    background-color: #f5f5f5;
    align-items: center;
    border-top: 1px solid #e0e0e0;

    @media (min-width: ${desktopBreakpoint.min}px) {
        display: flex;
        max-width: 83rem;
        margin: 0 auto;
        padding: 0 1.8rem;
    }

    @media only screen and (min-width: ${wideScreenBreakpoint.min}px) {
        display: flex;
        max-width: 83rem;
        margin: 0 auto;
        padding: 0 4.25rem;
    }
`

export const CountryList = styled.ul`
    display: flex;
    align-items: center;
    gap: 0.75rem;
    list-style: none;
`

export const SeoHref = styled(ExternalLink)`
    text-decoration: none;
`

export const ArrowIcon = styled(ChevronDownIcon)`
    margin-left: 0.25rem;
    transition: transform 0.3s ease;
    width: 0.75rem;
    height: 0.75rem;
`

export const MegaDropdownContainer = styled.li`
    position: relative;

    &:nth-child(n + 8) {
        display: none;
    }

    &:hover > div:last-child {
        opacity: 1;
        visibility: visible;
        transform: translateY(0);
    }

    &:hover svg {
        transform: rotate(180deg);
    }

    @media only screen and (min-width: ${wideScreenBreakpoint.min}px) {
        &:nth-child(n + 8) {
            display: list-item;
        }

        &:nth-child(n + 10) {
            display: none;
        }
    }
`

export const CountryTrigger = styled.button(
    ({ theme }) => css`
        cursor: pointer;
        display: flex;
        align-items: center;
        border: none;
        padding: 0.6rem 0.8rem;
        font-size: 1rem;
        transition: background-color 0.2s ease, color 0.2s ease;
        border-radius: 0.25rem;

        &:hover {
            background-color: ${theme.colors.white};
            color: ${theme.colors.tfwBlack87};
        }
    `,
)

export const CountryDropdown = styled.div`
    position: absolute;
    top: 100%;
    left: 0;
    transform: translateY(0.625rem);
    background-color: #fff;
    box-shadow: 0 0.25rem 1.5rem rgba(0, 0, 0, 0.1);
    border-radius: 0.375rem;
    min-width: 15.6rem;
    z-index: 10;

    opacity: 0;
    visibility: hidden;
    transition: opacity 0.25s ease, transform 0.25s ease, visibility 0.25s ease;
`

export const DropdownRegionHeading = styled.h4`
    font-size: 1.1rem;
    font-weight: 600;
    margin: 0;
    padding: 1rem 1.5rem 0.5rem;
`

export const RegionsList = styled.ul`
    display: flex;
    flex-direction: column;
    list-style: none;
`

export const RegionItem = styled.li(
    ({ theme }) => css`
        font-size: 0.95rem;
        padding: 0.65rem 1.5rem;
        transition: background-color 0.2s ease;

        a {
            text-decoration: none;
            color: inherit;
        }

        &:hover {
            background-color: ${theme.colors.tfwBlack12};
        }
    `,
)

export const CountryName = styled.span`
    font-weight: 500;
    font-size: 0.95rem;
`
